import React, { useEffect, useState } from 'react';
import '../assets/css/planselection.css';
import CardMediaExample from '../components/SimplePackageCardComponent';
import PackageCardComponent from '../components/PackageCardComponent';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { withStyles } from "@material-ui/core/styles";
import { PACKAGES } from '../assets/shared/packages';
import sendEventToEventLogs from '../helpers/events';
import { getBaseUrl } from '../helpers/razorpay';
import CryptoJS from 'crypto-js';
import { withRouter } from "react-router-dom";
import useDataStore from '../store/dataStore';
import RenewalSearchComponent from '../components/RenewalSearchComponent';

function PlanSelectionComponent({ classes, history }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [packages, setPackages] = useState([]);
  const [showHeaders, setShowHeaders] = useState(true);
  const packageData = useDataStore((state) => state.data);

  useEffect(() => {
    sendEventToEventLogs("AFFINITY_HOMEPAGE", "");
    const decryptWithAES = (encrypted_json_string, passphrase) => {
      var obj_json = JSON.parse(Buffer.from(encrypted_json_string, 'base64').toString());
      var encrypted = obj_json.ciphertext;
      var salt = CryptoJS.enc.Hex.parse(obj_json.salt);
      var iv = CryptoJS.enc.Hex.parse(obj_json.iv);
      var key = CryptoJS.PBKDF2(passphrase, salt, { hasher: CryptoJS.algo.SHA512, keySize: 64 / 8, iterations: 999 });
      var decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv: iv });
      return decrypted.toString(CryptoJS.enc.Utf8);
    };

    let source = new URLSearchParams(window.location.search).get('utm_source');
    let packageName = new URLSearchParams(window.location.search).get('utm_content');
    localStorage.setItem("source", source);
    let details;
    let utm_medium;
    

    const result=packageData.packages; 
      details = new URLSearchParams(window.location.search).get('details');
      if (details)
        localStorage.setItem("details", decryptWithAES(details, result[0].privateKey));
      else
        localStorage.removeItem("details");
    
      utm_medium = new URLSearchParams(window.location.search).get('utm_medium');
      if (utm_medium)
        localStorage.setItem("utm_medium", utm_medium);
      else
        localStorage.removeItem("utm_medium");
    
    setIsLoaded(true);
    setPackages(result);
    console.log(result);
    if (packageName) {
      for (let i = 0; i < result.length; i++) {
        if (result[i].title === packageName) {
          gtag("event", "plan_selection", {
            price: result[i].price,
            PackageName: result[i].title,
            packageId: result[i].id,
            walletAmount: result[i].walletAmount,
          });
          return history.push('/Checkout', { params: { packageDetails: result[i], isAuthentic: true } });
        }
      }
    }
    gtag("event", "affinity_page_view");

  }, []);

  if (packages === undefined || packages.error) {
    return <div></div>;
  }

  const SimplePackagesList = packages.map((packag) => {
    if (packag.complexStructure === false)
      return (
        <Grid item xs={12} sm={8} md={6} key={packag.id}>
          <CardMediaExample packag={packag} hidePrice={packageData.hidePrice}/>
        </Grid>
      );
  });

  const ComplexPackagesList = packages.map((packag) => {
    if (packag.complexStructure === true)
      return (
        <PackageCardComponent packag={packag} key={packag.id} />
      );
  });

  return (
    <div>
      {showHeaders && (
        <div className="planHeader">
          <h4 className="planSubHeading">{(packageData.differentPlanHeader && packageData.customePlanSelectionHeader) ? packageData.customePlanSelectionHeader :"Select Best Plans For You"}</h4>
        </div>
      )}
      <div className="PlanBackground" id="gh">
        <Container className={classes.root}>
          {packageData && packageData.renewalConfig && packageData.renewalConfig.enabled && (
            <RenewalSearchComponent
              renewalConfig={packageData.renewalConfig}
              packages={packages}
              history={history}
            />
          )}
          <Grid container spacing={4} justify="center" alignContent='space-around'>
            {SimplePackagesList}
          </Grid>
          {ComplexPackagesList}
        </Container>
      </div>
    </div>
  );
}

const styles = theme => ({
  root: {
    width: "70%",
    [theme.breakpoints.down('md')]: {
      width: '85%'
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%'
    }
  }
});

export default withRouter(withStyles(styles, { withTheme: true })(PlanSelectionComponent));
